import { ITimelineAction, ITimelineState } from './timeline.types'
import { TimelineConstants } from './timeline.constants'
import { TabConstants } from '../../../components/tabs/Tabs.constants'

export const initialActionsList = [
  {
    id: 1,
    name: 'Medications',
    action: TabConstants.ADD_MEDICATIONS_ADMINISTERED,
  },
  {
    id: 2,
    name: 'Cardiac',
    action: TabConstants.CARDIAC_PROCEDURE,
  },
  {
    id: 3,
    name: 'Intubation',
    action: TabConstants.INTUBATION_PROCEDURE,
  },
  {
    id: 4,
    name: 'Airway',
    action: TabConstants.AIRWAY_PROCEDURE,
  },
  {
    id: 5,
    name: 'Childbirth / OB',
    action: TabConstants.CHILDBIRTHOB_PROCEDURE,
  },
  {
    id: 6,
    name: 'Initiate IV',
    action: TabConstants.INITIATE_IV_PROCEDURE,
  },
  {
    id: 7,
    name: 'Immobilization',
    action: TabConstants.IMMOBILIZATION_PROCEDURE,
  },
  {
    id: 8,
    name: 'Medical Consult',
    action: TabConstants.MEDICAL_CONSULT_PROCEDURE,
  },
  {
    id: 9,
    name: 'Extrication',
    action: TabConstants.EXTRICATION_PROCEDURE,
  },
  {
    id: 10,
    name: 'Rescue',
    action: TabConstants.RESCUE_PROCEDURE,
  },
  {
    id: 11,
    name: 'Ventilator',
    action: TabConstants.VENTILATOR_PROCEDURE,
  },
  {
    id: 12,
    name: 'Hospital Notify',
    action: TabConstants.HOSPITAL_NOTIFY_PROCEDURE,
  },
  {
    id: 13,
    name: 'Wound Care',
    action: TabConstants.WOUND_CARE_PROCEDURE,
  },
  {
    id: 14,
    name: 'Imaging / Ultrasound',
    action: TabConstants.IMAGING_ULTRASOUND_PROCEDURE,
  },
  {
    id: 15,
    name: 'Drain',
    action: TabConstants.DRAIN_PROCEDURE,
  },
  {
    id: 16,
    name: 'Titrate',
    action: TabConstants.TITRATE_PROCEDURE,
  },
  {
    id: 17,
    name: 'Operations',
    action: TabConstants.OPERATIONS_PROCEDURE,
  },
  {
    id: 18,
    name: 'Labs',
    action: TabConstants.LABS_PROCEDURE,
  },
  {
    id: 19,
    name: 'Pertinent Negative Procedure',
    action: TabConstants.PERTINENT_NEGATIVE_PROCEDURE,
  },
  {
    id: 20,
    name: 'Pertinent Negative Medication',
    action: TabConstants.PN_MEDICATION_PROCEDURE,
  },
  {
    id: 21,
    name: 'Blood Product Administration',
    action: TabConstants.BLOOD_PRODUCT_ADMINISTRATION_PROCEDURE,
  },
  {
    id: 22,
    name: 'Ventricular Assist Device',
    action: TabConstants.VENTRICULAR_ASSIST_DEVICE_PROCEDURE,
  },
  {
    id: 23,
    name: 'Critical Care',
    action: TabConstants.CRITICAL_CARE_PROCEDURE,
  },
  {
    id: 24,
    name: 'Assessments',
    action: TabConstants.ASSESSMENT_PROCEDURE,
  },
]

export const initialTimelineState: ITimelineState = {
  segment: 'Timeline',
  showCameraModal: false,
  showMonitorModal: false,
  showClearFiltersButton: false,
  imgSource: '',
  vitalItem: null,
  items: [],
  actionsList: initialActionsList,
  selectedItem: null,
  filterChips: [],
  selectedFilterChipType: '',
  procedureLoader: false,
  deleteVitalsPrompt: false,
  deleteParentVitals: false,
  isEditMode: false,
  editedKeys: [],
  ptaToSync: false,
  deleteProcedurePrompt: false,
  deleteProcedure: false,
}

export function timelineReducer(state: ITimelineState = initialTimelineState, action: ITimelineAction): ITimelineState {
  switch (action.type) {
    case TimelineConstants.NOT_IMPLEMENTED:
      alert('Not Implemented')
      return state
    case TimelineConstants.SET_SEGMENT:
      return { ...state, segment: action.segment }
    case TimelineConstants.CAMERA_MODAL:
      return { ...state, showCameraModal: true }
    case TimelineConstants.MONITOR_MODAL:
      return { ...state, showMonitorModal: true }
    case TimelineConstants.FILTER_VITALS:
      return { ...state, selectedFilterChipType: TimelineConstants.FILTER_VITALS }
    case TimelineConstants.FILTER_PROCEDURES:
      return { ...state, selectedFilterChipType: TimelineConstants.FILTER_PROCEDURES }
    case TimelineConstants.FILTER_ASSESSMENTS:
      return { ...state, selectedFilterChipType: TimelineConstants.FILTER_ASSESSMENTS }
    case TimelineConstants.FILTER_ECG:
      return { ...state, selectedFilterChipType: TimelineConstants.FILTER_ECG }
    case TimelineConstants.FILTER_TIMES:
      return { ...state, selectedFilterChipType: TimelineConstants.FILTER_TIMES }
    case TimelineConstants.FILTER_MEDICATIONS:
      return { ...state, selectedFilterChipType: TimelineConstants.FILTER_MEDICATIONS }
    case TimelineConstants.CLEAR_FILTERS:
      return { ...state, selectedFilterChipType: TimelineConstants.CLEAR_FILTERS }
    case TimelineConstants.RESET_TIMELINE:
      return { ...state, showMonitorModal: false, showCameraModal: false }
    case TimelineConstants.ADD_TO_ACTIVITY_LOG:
      return { ...state, items: [...state.items, action.item] }
    case TimelineConstants.SET_ACTIVITY_LOG:
      return { ...state, items: action.items }
    case TimelineConstants.SET_VITAL_ITEM:
      return { ...state, vitalItem: action.payload }
    case TimelineConstants.SET_ADD_MEDICATION_ADMINISTERED_ITEM:
      return { ...state, selectedItem: action.payload }
    case TimelineConstants.SET_INTUBATION_PROCEDURE_ITEM:
      return { ...state, selectedItem: action.payload }
    case TimelineConstants.SET_CARDIAC_PROCEDURE_ITEM:
      return { ...state, selectedItem: action.payload }
    case TimelineConstants.SET_IMAGING_ULTRASOUND_ITEM:
      return { ...state, selectedItem: action.payload }
    case TimelineConstants.SET_FILTERED_ITEMS:
      return { ...state, filteredItems: action.filteredItems }
    case TimelineConstants.SET_TIMES_ITEM:
      return { ...state, selectedItem: action.payload }
    case TimelineConstants.DELETE_TIMELINE_ITEM:
      return { ...state, selectedItem: action.payload }
    case TimelineConstants.SET_FILTER_CHIPS:
      return { ...state, filterChips: action.filterChips }
    case TimelineConstants.SET_SHOW_CLEAR_FILTER_BUTTON:
      return { ...state, showClearFiltersButton: action.showClearFiltersButton }
    case TimelineConstants.SELECTED_FILTER_CHIP_TYPE:
      return { ...state, selectedFilterChipType: action.selectedFilterChipType }
    case TimelineConstants.SET_AIRWAY_PROCEDURE_ITEM:
      return { ...state, selectedItem: action.payload }
    case TimelineConstants.SET_PROCEDURE_LOADER:
      return { ...state, procedureLoader: action.procedureLoader }
    case TimelineConstants.SET_CHILDBIRTHOB_PROCEDURE_ITEM:
      return { ...state, selectedItem: action.payload }
    case TimelineConstants.SET_INITIATE_IV_PROCEDURE_ITEM:
      return { ...state, selectedItem: action.payload }
    case TimelineConstants.SET_IMMOBILIZATION_PROCEDURE_ITEM:
      return { ...state, selectedItem: action.payload }
    case TimelineConstants.SET_MEDICAL_CONSULT_PROCEDURE_ITEM:
      return { ...state, selectedItem: action.payload }
    case TimelineConstants.SET_EXTRICATION_PROCEDURE_ITEM:
      return { ...state, selectedItem: action.payload }
    case TimelineConstants.SET_OPERATIONS_PROCEDURE_ITEM:
      return { ...state, selectedItem: action.payload }
    case TimelineConstants.SET_RESCUE_PROCEDURE_ITEM:
      return { ...state, selectedItem: action.payload }
    case TimelineConstants.SET_VENTILATOR_PROCEDURE_ITEM:
      return { ...state, selectedItem: action.payload }
    case TimelineConstants.SET_HOSPITAL_NOTIFY_PROCEDURE_ITEM:
      return { ...state, selectedItem: action.payload }
    case TimelineConstants.SET_WOUND_CARE_PROCEDURE_ITEM:
      return { ...state, selectedItem: action.payload }
    case TimelineConstants.SET_DRAIN_PROCEDURE_ITEM:
      return { ...state, selectedItem: action.payload }
    case TimelineConstants.SET_TITRATE_PROCEDURE_ITEM:
      return { ...state, selectedItem: action.payload }
    case TimelineConstants.SET_LABS_PROCEDURE_ITEM:
      return { ...state, selectedItem: action.payload }
    case TimelineConstants.SET_PN_PROCEDURE_ITEM:
      return { ...state, selectedItem: action.payload }
    case TimelineConstants.SET_VENTRICULAR_ASSIST_DEVICE:
      return { ...state, selectedItem: action.payload }
    case TimelineConstants.SET_CRITICAL_CARE_PROCEDURE_ITEM:
      return { ...state, selectedItem: action.payload }
    case TimelineConstants.SET_ASSESSMENT:
      return { ...state, selectedItem: action.payload }
    case TimelineConstants.SET_ACTIONS_LIST:
      return { ...state, actionsList: action.actionsList }
    case TimelineConstants.SET_PN_MEDICATION_ITEM:
      return { ...state, selectedItem: action.payload }
    case TimelineConstants.SET_DELETE_VITALS_PROMPT:
      return { ...state, deleteVitalsPrompt: action.deleteVitalsPrompt }
    case TimelineConstants.SET_DELETE_PARENT_VITALS:
      return { ...state, deleteParentVitals: action.deleteParentVitals }
    case TimelineConstants.RESET_TIMELINE_STATE:
      return initialTimelineState
    case TimelineConstants.SET_IS_EDIT_MODE:
      return { ...state, isEditMode: action.isEditMode, editedKeys: [] }
    case TimelineConstants.SET_EDITED_ITEM:
      return { ...state, selectedItem: action.payload }
    case TimelineConstants.SET_EDITED_KEYS:
      return { ...state, editedKeys: action.editedKeys }
    case TimelineConstants.SYNC_PTA_WITH_PARENT_VITALS:
      return { ...state, ptaToSync: action.ptaToSync }
    case TimelineConstants.SET_DELETE_PROCEDURE_PROMPT:
      return { ...state, deleteProcedurePrompt: action.deleteProcedurePrompt }
    case TimelineConstants.SET_DELETE_PROCEDURE:
      return { ...state, deleteProcedure: action.deleteProcedure }
    case TimelineConstants.SET_BLOOD_PRODUCT_ADMINISTRATION:
      return { ...state, selectedItem: action.payload }
    default:
      return state
  }
}
